import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getBrand = async () => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: '/brand/list' });

  return data;
};

export default getBrand;
